// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/components/modal/modal.less
// module id = 3015
// module chunks = 0